import { useState, memo, useCallback, useEffect, useContext } from "react";
import styles from "./hotel.module.css";
import ReviewPopup from "../components/reviewPopup/reviewPopup";
import Button from "../components/button/button";
import { useNavigate, useSearchParams } from "react-router-dom";
import Reviews from "./Components/Reviews";
import HotelMainRating from "./Components/HotelMainRating";
import HotelPageHeader from "./Components/HotelPageHeader";
import Dropdown from "../components/Dropdown/Dropdown";
import { buildAutieReviewSummary, options } from "./hotel.helper";
import { getGoogleHotel, getHotel, getReviewsData } from "../services/api";
import Loading from "../components/Loading/Loading";
import { UserDataContext } from "../Context/Context";

const HotelReview = () => {
  const [showWritePopup, setShowWritePopup] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [hotel, setHotel] = useState([]);
  const [sortBy, setSortBy] = useState('');
  const [searchParams] = useSearchParams();
  const [reviews, setReviews] = useState([]);
  const [myReview, setMyReview] = useState(false);
  const [refreshReviews, setRefreshReviews] = useState(false);
  const [reviewsLoading, setreviewsLoading] = useState(false);
  const navigate = useNavigate();
  const { user } = useContext(UserDataContext);
  const hotelID = searchParams.get("hotelID")
  const googlePlaceId = searchParams.get("googlePlaceId")

  useEffect(() => {
    async function getAllReviews() {
      setreviewsLoading(true)
      try {
        if (!hotelID && !googlePlaceId) {
          setHotel({ error: "Hotel not found" });
          setReviews([]);
          setMyReview(false);
          setreviewsLoading(false);
          return;
        }

        let hotel = googlePlaceId ? await getGoogleHotel(googlePlaceId) : await getHotel(hotelID)
        let reviews = await getReviewsData(googlePlaceId ? null : hotelID, null, googlePlaceId)
        let myreviews = reviews?.length > 5000
          ? await getReviewsData(googlePlaceId ? null : hotelID, "userReview", googlePlaceId)
          : reviews?.filter(r => r?.User?.username === user.username);

        setHotel(buildAutieReviewSummary(hotel, reviews))
        setReviews(reviews)
        setMyReview(myreviews?.length > 0 ? myreviews[0] : false)
      } finally {
        setreviewsLoading(false)
      }
    }
    getAllReviews()
  }, [hotelID, googlePlaceId, refreshReviews, user]);

  const handleSortChange = useCallback((e) => setSortBy(e.target.value), []);
  const closePopup = (type) => {
    if (type === "reviewWrite") setShowWritePopup(false);
    if (type === "reviewEdit") setShowEditPopup(false);
  };

  return (
    hotel?.id || hotel?.placeId ? <>
      <div className={styles.parent}>
        <HotelPageHeader hotel={hotel} reviews={reviews?.length} />
        <div className={styles.reviewContainer}>
          <div className={styles.first}>
            <Dropdown
              id='orderReviews'
              options={options}
              onChange={handleSortChange} />
            <Button
              style={{ 'width': '190px', borderRadius: "50px", marginTop: "0" }}
              onClick={() => myReview ? setShowEditPopup(true) : setShowWritePopup(true)}
              children={myReview ? 'Edit a Review' : 'Write a Review'}
            />
          </div>
          <HotelMainRating hotel={hotel} reviews={reviews?.length} />
          <hr style={{ margin: "24px 0", opacity: '0.3' }} />
          <Reviews hotel={hotel} order={sortBy} reviews={reviews} reviewsLoading={reviewsLoading} />
        </div>
      </div>
      <ReviewPopup
        reviewEditPopup={showEditPopup}
        reviewWritePopup={showWritePopup}
        closePopup={closePopup}
        hotelReviewData={myReview}
        hotelID={hotelID}
        googlePlaceId={googlePlaceId}
        setRefreshReviews={setRefreshReviews}
      />
    </> : hotel.error ? <div className={styles.notFound}>
      <p style={{ fontSize: "1.5rem", color: "#662D91" }}>{hotel.error}</p>
      <Button style={{ width: "180px", marginTop: "20px" }} onClick={() => navigate('/')}>Go Home</Button>
    </div> : <Loading />
  );
};

export default memo(HotelReview)
